import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { initAuthTokenRuntime } from './services/authToken';

initAuthTokenRuntime();

type RuntimeProps = Partial<{
  hostAuthResult: unknown;
  externalRefUserId: string;
}>;

const runtimeWindow = window as Window & {
  __DIAGNOSTICS_PROPS__?: RuntimeProps;
  __MFE_PROPS__?: RuntimeProps;
};

const runtimeProps = runtimeWindow.__DIAGNOSTICS_PROPS__ ?? runtimeWindow.__MFE_PROPS__ ?? {};

if (process.env.NODE_ENV !== 'production') {
  console.info('[DiagnosticsVersion] runtime signature', {
    diagnosticsRuntime: 'diagnostics-auth-runtime-2026-07-16.1',
    loreMfeKit: '2.0.1',
    embedded: window.parent !== window,
    hasHostAuthResult: typeof runtimeProps.hostAuthResult === 'object' && runtimeProps.hostAuthResult !== null,
    runtimePropKeys: Object.keys(runtimeProps),
    externalRefUserIdPresent: typeof runtimeProps.externalRefUserId === 'string' && runtimeProps.externalRefUserId.trim().length > 0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App {...runtimeProps} />
    </Provider>
  </React.StrictMode>,
);
